import { path } from 'ramda';
import { languageOverrideQueryParam } from '../../modules/infra/i18n/language-selection-utils/constants';

export const CONTAINER_APP = 'containerApp';

export const isActive = (history) => {
  const containerApp = path(
    ['query', CONTAINER_APP],
    history.getCurrentLocation(),
  );


  return Boolean(containerApp);
};

export const persistQuery = (prevState, nextState, replace, callback) => {
  const getContainerApp = path(['location', 'query', CONTAINER_APP]);
  const getLanguageOverride = path(['location', 'query', languageOverrideQueryParam]);

  const newState = {
    pathname: nextState.location.pathname,
    query: {
      ...nextState.location.query,
    },
  };

  const isContainerAppNeedChanging = getContainerApp(prevState) && !getContainerApp(nextState);
  if (isContainerAppNeedChanging) {
    newState.query[CONTAINER_APP] = true;
  }

  const isLanguageOverrideNeedChanging =
    getContainerApp(prevState) &&
    getLanguageOverride(prevState) &&
    getLanguageOverride(prevState) !== getLanguageOverride(nextState);
  if (isLanguageOverrideNeedChanging) {
    newState.query[languageOverrideQueryParam] = getLanguageOverride(prevState);
  }

  if (isContainerAppNeedChanging || isLanguageOverrideNeedChanging) {
    replace(newState);
  }

  callback();
};

export const isEngageRoute = (history) => {
  const { pathname } = history.getCurrentLocation();
  return pathname.includes('/engagement') || pathname.includes('/engagement-v2');
};
